'use client';

import React from 'react';
import dynamic from 'next/dynamic';

const StorageDonut = dynamic(() => import('./StorageDonut'), { ssr: false });

const STORAGE_USED_MB = 731;
const STORAGE_TOTAL_MB = 1024;
const STORAGE_PCT = Math.round((STORAGE_USED_MB / STORAGE_TOTAL_MB) * 100);

export default function StorageWidget() {
  const isWarning = STORAGE_PCT >= 70;
  const isDanger = STORAGE_PCT >= 90;

  return (
    <div>
      <div className="flex items-center justify-between mb-2">
        <span className="text-xs font-semibold text-muted-foreground uppercase tracking-wider">
          Drive storage
        </span>
        <span className={`text-xs font-semibold tabular-nums ${isDanger ? 'text-danger' : isWarning ? 'text-warning' : 'text-muted-foreground'}`}>
          {STORAGE_PCT}%
        </span>
      </div>

      <div className="flex items-center gap-3">
        <div className="flex-shrink-0">
          <StorageDonut pct={STORAGE_PCT} />
        </div>
        <div className="flex-1 min-w-0">
          <p className={`text-sm font-semibold tabular-nums ${isDanger ? 'text-danger' : isWarning ? 'text-warning' : 'text-foreground'}`}>
            {STORAGE_USED_MB} MB used
          </p>
          <p className="text-xs text-muted-foreground">
            of {(STORAGE_TOTAL_MB / 1024)?.toFixed(0)} GB free tier
          </p>
          {isWarning && (
            <p className={`text-xs mt-0.5 font-medium ${isDanger ? 'text-danger' : 'text-warning'}`}>
              {isDanger ? 'Storage almost full' : 'Running low'}
            </p>
          )}
        </div>
      </div>

      <div className="mt-2 h-1.5 rounded-full bg-muted overflow-hidden">
        <div
          className={`h-full rounded-full transition-all duration-500 ${
            isDanger ? 'bg-danger' : isWarning ? 'bg-warning' : 'bg-primary'
          }`}
          style={{ width: `${STORAGE_PCT}%` }}
        />
      </div>
    </div>
  );
}